import { Component, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input, OnInit } from '@angular/core';
import { AuthenticationState, AuthInfo } from './authentication-state';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { UrlBuilder } from '../core/url-builder/url-builder';

@Component({
    selector: 'login-page',
    template: require('./login-page.component.html'),
    styles: [require('./login-page.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginPageComponent implements OnInit, OnDestroy {
    public displayLoginWidget = false;

    private authInfoSubscription: Subscription;

    constructor(private authenticationState: AuthenticationState, private urlBuilder: UrlBuilder, private changeDetector: ChangeDetectorRef) {
        this.authInfoSubscription = authenticationState.authInfo.pipe(first())
            .subscribe(this.onAuthInfoLoad);
    }

    public ngOnDestroy() {
        this.authInfoSubscription.unsubscribe();
    }

    public ngOnInit() {
        this.authenticationState.login();
    }

    private onAuthInfoLoad = (authInfo: AuthInfo) => {
        this.changeDetector.markForCheck();

        if (authInfo.isAuthenticated) {
            this.urlBuilder.esa().navigateToReturnUrl();
        } else {
            this.displayLoginWidget = true;
        }
    }

}